
export const adaptDatosPrincipales = (datosPrincipales, idEvaluacion, idUsuario, idDelegacion, idTipoEvaluacion, idPrePaciente) => {
    return {
        addDatosPrincipalesInput: {
            idEvaluacion: parseInt(idEvaluacion) || null,
            idTipoEvaluacion: idTipoEvaluacion,
            fechaAlta: datosPrincipales?.fechaAlta,
            idCliente: datosPrincipales?.idCliente,
            idClienteSubVenta: datosPrincipales?.idClienteSubVenta,
            numeroAfiliado: datosPrincipales?.numeroAfiliado,
            idLugarServicio: parseInt(datosPrincipales?.idLugarServicio),
            idUsuario: parseInt(idUsuario),
            idInstitucion: datosPrincipales?.idInstitucion,
            idDerivador: parseInt(datosPrincipales?.idDerivador),
            idDerivadorExterno: parseInt(datosPrincipales?.idDerivadorExterno),
            idDelegacion: parseInt(idDelegacion),
            tipoDerivador: datosPrincipales?.tipoDerivador,
            idTipoModulo: parseInt(datosPrincipales?.idTipoModulo),
            codigoDiagnosticoTraditum: datosPrincipales?.codigoDiagnosticoTraditum,
            //prestadorPrescriptor: datosPrincipales?.prestadorPrescriptor,
            identificadorPrestadorPrescriptor : datosPrincipales?.identificadorPrestadorPrescriptor,
            financiadorParticular: (datosPrincipales?.financiadorParticular ?? false).toString(),
            derivacionPrescriptor: datosPrincipales?.derivacionPrescriptor,
            idCentroReferencia: datosPrincipales?.idCentroReferencia,
            observaciones: datosPrincipales?.observaciones,
            derivadorOS: datosPrincipales.derivadorOS,
            telefonoMedicoContacto: datosPrincipales?.telefonoMedicoContacto?.toString(),
            medicoContacto: datosPrincipales?.medicoContacto,
            idCanal: datosPrincipales?.idCanal,
            detalleCanal: datosPrincipales?.detalleCanal,
            idPrePaciente: idPrePaciente
        },
        addPacienteInput: {
            idPaciente: parseInt(datosPrincipales?.idPaciente),
            nombre: datosPrincipales?.nombre,
            apellido: datosPrincipales?.apellido,
            mail: datosPrincipales?.mail,
            edad: datosPrincipales?.edad,
            sexo: datosPrincipales?.sexo,
            familiar: datosPrincipales?.familiar,
            familiarTelefono: datosPrincipales?.familiarTelefono?.toString(),
            tipoDerivador: datosPrincipales?.tipoDerivador,
            codSAPPaciente: datosPrincipales?.codSAPPaciente,
            idTipoDocumento: datosPrincipales?.idTipoDocumento,
            numeroDocumento: datosPrincipales?.numeroDocumento,
            idDelegacion: parseInt(idDelegacion),
            fechaAlta: datosPrincipales?.fechaAlta,
            fechaNacimiento: datosPrincipales?.fechaNacimiento,
            idCliente: datosPrincipales?.idCliente,
            responsable: datosPrincipales?.responsable,
            sinDoc: datosPrincipales?.sinDoc,
            telefonoContacto: datosPrincipales?.telefonoContacto?.toString(),
        }
    }
}